/**
 * @Dependencies
 * 
 *  Materializecss.com Select
 * 
 * @Resources
 * 
 *  https://materializecss.com/select.html
 */
import React from 'react';

import './StepSelectOptions.css';

const StepSelectOptions = ({
    stepText,
    stepInfo,
    options,
    interactionData,
    nullOption,
    onOptionChange
}) => {

    const selectRef = React.useRef(null);
    const [materializeSelectInstance, setMaterializeSelectInstance] = React.useState(null);

    React.useEffect(() => {
        materializeSelectInit();
    }, []);

    React.useEffect(() => {
        selectUpdate(materializeSelectInstance,  interactionData.selectedOptionId);

    }, [interactionData]);

    const materializeSelectInit = () => {
        // eslint-disable-next-line no-undef
        M.FormSelect.init(selectRef.current);
        // eslint-disable-next-line no-undef
        setMaterializeSelectInstance(M.FormSelect.getInstance(selectRef.current));
    };

    /**
     * Updates the Select with value.
     * Two elements are updated:
     *  1. The actual HTMLSelect stored in selectRef.current
     *  2. The HTMLInput text field stored in materializeSelectInstance.input (this is used by Materializecss Select to display the selected value)
     * @param {Object} materializeSelectInstance 
     * @param {String} value 
     */
    const selectUpdate = (materializeSelectInstance, value) => {
        selectRef.current.value = value;
        if (materializeSelectInstance) {
            materializeSelectInstance.input.value = value;
        }
    };

    const renderOptionsHtml = (options, stepInfo) =>  {
        return (
            <div className="input-field col s12">
                <select ref={ selectRef } onChange={ (evt) => {
                    onOptionChange(evt.target.value)
                } }>
                    { options.map(option => renderOptionHtml(option)) }
                </select>
            </div>
        );
    }

    const renderOptionHtml = (option) => (
        <option
            key={ option.value }
            value={ option.value }>
            { option.label }
        </option>
    );

    return (
        <div className="slc-step-options-select">
            <div className="slc-step-options-select__text slc-step-text--title">
                { stepText }
            </div>
            { stepInfo && (
                <div className="slc-step-options-select__text slc-step-text--info">
                    { stepInfo }
                </div>
            )}
            <div className="slc-step-options-select__options">
                { renderOptionsHtml(options, stepInfo) }
            </div>
        </div>
    );

};

export default StepSelectOptions;